// extracted by mini-css-extract-plugin
module.exports = {"withDragAction":"OperatorWidget_withDragAction__3UFF7","disabled":"OperatorWidget_disabled__1aS1i"};